<template>
  <v-slide-y-transition mode="out-in">
    <v-layout row wrap>
      <v-flex lg12 sm12 xs12 class="tabular">
        <v-card elevation="0">
          <v-card-text class="px-0">
            <v-layout row>
              <v-flex xs4 md3>
                <v-text-field v-model="persen_pemilih" label="Persen Pemilih" outlined dense hide-details></v-text-field>
              </v-flex>              
              <v-flex xs4 md3>
                <v-text-field v-model="kuota_local" label="Kuota Kursi" outlined dense hide-details></v-text-field>
              </v-flex>         
              <v-flex xs4 md6>
                <v-btn color="success" dark @click="export2excel(question.no)" small style="float:right">
                  <v-icon left>select_all</v-icon>.xls
                </v-btn>
              </v-flex>     
            </v-layout>
          </v-card-text>
          <v-card-text class="pa-0 v-data-table__wrapper" style="overflow:auto">
            <div class="v-table__overflow tabular" :id="'slm'+question.no">   
              <table id="sainte">
                <thead>
                  <tr>
                    <th rowspan="2">No.</th>
                    <th rowspan="2">Nama</th>
                    <th rowspan="2">Elek</th>
                    <th rowspan="2">Dpt</th>
                    <th rowspan="2">Partisipasi Pemilih ({{persen_pemilih}}%)</th>
                    <th rowspan="2">Suara</th>
                    <th :colspan="kuota_local">Sainte Lague</th>
                    <th rowspan="2">Kursi dimenangkan</th>                
                    <th rowspan="2">Jumlah Kemenangan</th> 
                    
                  </tr>
                  <tr>
                    <th v-for="(i) in parseInt(kuota_local)">{{i}}</th>
                  </tr>  
                </thead>
                <tbody v-if="show">
                  <tr v-for="(calon,j) in partais" >
                    <td class="text-xs-center" valign="top">{{calon.no}}</td>
                    <td class="text-xs-center cursor" valign="top" style="min-width:200px">{{calon.name}}</td>
                    <td class="text-right cursor" valign="top">{{parseFloat(calon.elek).toFixed(2)}}%</td>
                    <td class="text-right cursor" valign="top">{{calon.dpt}}</td>
                    <td class="text-right cursor" valign="top">{{calon.pemilih}}</td>
                    <td class="text-right cursor" valign="top">{{calon.suara}}</td>
                    <td v-for="(t,i) in parseInt(kuota_local)" v-bind:class="maxIndex[i] === j?'success white--text':''" class="text-right" style="min-width:70px" valign="top">
                      <small>{{origin[i][j]}} / {{pembagi[i][j]}}</small><br/>                  
                      <strong>{{result[i][j]}}</strong>                  
                    </td>
                    <td class="text-right" style="min-width:100px" valign="top"><strong>{{calon.kursi.join(",")}}</strong></td>
                    <td class="text-right" valign="top"><strong>{{calon.seats}}</strong></td>
                    
                  </tr>
                </tbody>
              </table>          
            </div>  
          </v-card-text>
        </v-card>                      
      </v-flex>
    </v-layout>      
  </v-slide-y-transition>
</template>

<script>    
import Table2Excel  from 'table2excel.js';  
export default {  
  name: 'sainte-lague',  
  props:['question'],  
  data: () => ({        
    kuota_local   : 0,
    persen_pemilih: 65,
    partais : [],
    

    pagination : {'sortBy': 'value', 'descending': true, 'rowsPerPage': -1}, 
    
    origin  : [],
    pembagi : [],
    result  : [],        
    
    maxIndex : [],
    
    show : false    
  }),  
  watch:{
    kuota_local(){
      this.init()
    },
    persen_pemilih(){
      this.init()
    }
  },
  mounted(){
    this.kuota_local = this.question.kuota
    this.persen_pemilih = this.question.persen_pmlih
    this.init()
  },
  created(){
     
  },  
  methods: {  
   
    init(){
      let total = 0;              
      for(var i in this.question.demografi){
        total += parseInt(this.question.demografi[i].people)
      }

      this.partais = [];
      this.question.option.forEach((item,i)=>{        
        let data = {}, dpt = 0, elek = 0, pemilih = 0, suara = 0
        if((data= this.question.demografi.find(x=>x.answer == item.id))){
          dpt  = parseInt(data.dpt)
          elek = parseInt(data.people)/total * 100;
          pemilih = parseInt(parseFloat(this.persen_pemilih)/100*dpt)
          suara = parseInt(elek/100*pemilih)
        }
        if(item.value.toLowerCase().includes('tidak') && this.kuota_local > 2){} 
        else {
          this.partais.push({
            no:(i+1), 
            id:item.id, 
            name:item.value,
            elek: elek,
            dpt: dpt,
            pemilih: pemilih,
            suara: suara,
            value: suara,
            kursi: []
          })
        }        
      });

      //this.kuota_local = this.partais.length
      let calons   = this.partais;            
      let seats    = [];
      
      calons.forEach((calon,j)=>{
        seats[j] = 0;
      });
      
      var imax = -1; 
      var vmax =  0;
      for(var i=0; i<this.kuota_local; i++){
        this.origin[i]  = [];
        this.pembagi[i] = [];
        this.result[i]  = [];                             
        calons.forEach((calon,j)=>{             
          var ori = i === 0 ? (calon.value?calon.value:0) : this.origin[i-1][j];
          var per = i === 0 ? 1 : this.pembagi[i-1][j]; 
          
          if(imax === j){
            per = parseInt(this.pembagi[i-1][j]+2);            
          }
          
          this.origin[i][j] = ori;                    
          this.pembagi[i][j]= per;
          this.result[i][j] = parseInt(ori/per);                    
          vmax += ori;
        });
        imax = this.indexOfMax(this.result[i]);                
        seats[imax] += vmax > 0 ? 1 : 0;
        this.maxIndex[i] = vmax > 0 ? imax : -1;
      }

      
            
      calons.forEach((calon,j)=>{
        for(var i=0; i<this.kuota_local; i++){
          if(this.maxIndex[i] === j){
            this.partais[j].kursi.push(i+1);    
          }
        }
        this.partais[j].seats = seats[j];
      });
            
      this.show = true;
    },
    
    indexOfMax(arr) {
        if (arr.length === 0) {
            return -1;
        }

        var max = parseFloat(arr[0]);
        var maxIndex = 0;

        for (var i = 1; i < arr.length; i++) {
            if (parseFloat(arr[i]) > parseFloat(max)) {
                maxIndex = i;
                max = parseFloat(arr[i]);
            }
        }

        return maxIndex;
    },
    
    persenContain(contain){
        return (contain.done/contain.all*100).toFixed(2)
    },

    colorPersen(persen){
        if(persen >= 0 && persen <=40)return 'red';
        else if(persen <=60)return 'orange';
        else if(persen <=80)return 'yellow';
        else if(persen <=99)return 'blue';
        else return 'green';        
    },

    export2excel(i){
      var filename = 'SLM.'+i+'.';
      filename    += this.$moment().format('DDMMYY.HHmm');
      new Table2Excel('#slm'+i+' table',{
        plugins: [{
          workcellCreated ({ workbook, tables, worksheet, table, workcell, cell, cellStyle, rowRange, colRange }) {
            workcell.style = {
              ...workcell.style,
              font: {},
              color: '#000'
            }
          }
        }]
      }).export(filename);
    },
  }  
}
</script>
<style>
#sainte{border-collapse: collapse; width:100%}
#sainte th, #sainte td{border:1px solid #eee; padding:3px}
#sainte th{text-align: center}
</style>